module.exports = "/_next/static/images/f94df1b5b3689991425a461a6ddbe70c-invite-icon.svg.webp";